import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { AdministrationService } from '../../services/administration.service'

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private administrationService: AdministrationService,
  ) {}

  ngOnInit() {
    const adminId = this.route.snapshot.queryParams['administrationId']
    const relatedObjectId = this.route.snapshot.queryParams['related_object_id']
    const relatedObject = this.route.snapshot.queryParams['related_object']
    const page = this.route.snapshot.queryParams['page']
    let url = this.administrationService.getRemoteRedirect(adminId)

    if (page) {
      url += ';related_object_id=' + page
    } else {
      if (relatedObject) {
        url += ';related_object=' + relatedObject
      }
      if (relatedObjectId) {
        url += ';related_object_id=' + relatedObjectId
      }
    }

    window.open(url, '_blank')
    localStorage.removeItem('redirect') // Cleanup redirect url if it is there
    this.router.navigateByUrl('/administrations')
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/redirect/redirect.component.ts